import { Controller } from 'stimulus'

export default class extends Controller {

  // Inserting a new item is handled via new.js.erb, not this stimulus controller.

  static targets = ['itemsList', 'hideWhileCreating', 'hideWhileEditing']

  // Used for hiding the new item form creation or when 'cancel' is clicked.
  hideNewItem(event) {
    const new_item_form = event.target.closest(".item-form");

    if (new_item_form && new_item_form.parentNode) {
      new_item_form.parentNode.removeChild(new_item_form);
    }

    document.body.classList.remove("item-form-visible");

    if (!this.hasItemsListTarget) {
      const helpBox = this.element.querySelector('.help-box');
      if (helpBox) helpBox.classList.remove("hidden");
    }

    // Show elements hidden while creating
    if (this.hasHideWhileCreatingTarget) {
      this.hideWhileCreatingTargets.forEach(el => {
        if (el) el.classList.remove("hidden");
      });
    }
  }

  hideEditItem(event) {
    const item_div = event.target.closest(".items-list-item");
    if (!item_div) return;

    const edit_item_form = item_div.querySelector(".item-form");

    document.body.classList.remove("item-form-visible");

    if (edit_item_form && edit_item_form.parentNode) {
      edit_item_form.parentNode.removeChild(edit_item_form);
    }

    const content = item_div.querySelector(".item-content");
    if (content) content.classList.remove("hidden");

    item_div.classList.remove("no-drag");

    if (this.hasHideWhileEditingTarget) {
      this.hideWhileEditingTargets.forEach(el => {
        if (el) el.classList.remove("hidden");
      });
    }
  }
}
